import React, { FC } from "react";
import { ProjectContentItemDc } from "@evergis/api";

import { LayerItem } from "../../../LayerList/components/LayerItem";
import { useOutOfScale } from "../../../LayerList/hooks/useOutOfScale";
import { useLayerItem } from "../../../LayerList/hooks/useLayerItem";

type LegendLayerProps = {
  item: ProjectContentItemDc;
};

export const LegendLayer: FC<LegendLayerProps> = ({ item }) => {
  const layerItemInfo = useLayerItem(item.name);
  const isOutOfScale = useOutOfScale(layerItemInfo.layer);

  return <LayerItem layer={item} isOutOfScale={isOutOfScale} layerItemInfo={layerItemInfo} noControl />;
};
